<template>
  <div class="supplier-evaluation">
    <!-- 固定头部导航 -->
    <div class="header fixed-top">
      <div v-if="currentPage !== 1" class="back-btn" @click="goBack">＜</div>
      <div v-if="currentPage === 1" class="title">供应商评价系统</div>

      <div v-else-if="currentPage === 2 || currentPage === 3" class="title">{{ evaluationTitle }}</div>
    </div>

    <!-- 页面内容区域 -->
    <div class="page-content">
      <!-- 页面1：首页 -->
      <div v-if="currentPage === 1" class="page-home">
        <div class="content">
          <div class="date">{{ currentDate }} · {{ currentWeekDay }}</div>
          <div class="greeting">您好，{{ userName }}</div>

          <div class="icons-grid">
            <div class="icon-item" @click="goTo(1)">
              <div class="icon"><i class="el-icon-suitcase"></i></div>
              <div class="label">衣·劳保服饰</div>
            </div>
            <div class="icon-item" @click="goTo(2)">
              <div class="icon"><i class="el-icon-dish"></i></div>
              <div class="label">食·餐饮服务</div>
            </div>
            <div class="icon-item" @click="goTo(3)">
              <div class="icon"><i class="el-icon-house"></i></div>
              <div class="label">租·设备租赁</div>
            </div>
            <div class="icon-item" @click="goTo(4)">
              <div class="icon"><i class="el-icon-truck"></i></div>
              <div class="label">行·差旅交通</div>
            </div>
            <div class="icon-item" @click="goTo(5)">
              <div class="icon"><i class="el-icon-user-solid"></i></div>
              <div class="label">人·劳务派遣</div>
            </div>
            <div class="icon-item" @click="goTo(6)">
              <div class="icon"><i class="el-icon-truck"></i></div>
              <div class="label">运·快递物流</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 页面2：餐饮项目列表 -->
      <div v-if="currentPage === 2" class="page-food">
        <div class="content">
          <div class="item-list" v-if="evaluationProjectList.length > 0">
            <div v-for="(item, index) in evaluationProjectList" :key="index" class="item" @click="goToEvaluation(item.ProjectId)">
              <div class="item-info">
                <div class="name">{{ item.ProjectAlias }}</div>
                <div class="supplier">供应商：{{ item.SupplierName }}</div>
              </div>
              <div class="action">去评价</div>
            </div>
          </div>
          <div v-else>暂无评价项目</div>
        </div>
      </div>

      <!-- 页面3：具体评价页 -->
      <div v-if="currentPage === 3" class="page-evaluation">
        <div class="content">
          <div class="section" v-for="(item, index) in questionnaireList" :key="index">
            <div class="section-title"><span style="color: #f00" v-if="item.Required">*</span>{{ item.SerialNum }}.{{ item.QuestionsName }}</div>
            <div v-if="item.QuestionsType == 5">
              <div class="rate-item" v-for="(item1, key) in item.QuestionsOptionsList" :key="key">
                <span class="label">{{ item1.Text }}</span>
                <el-rate v-model="item.QuestionsValueList[key]" :max="5" :colors="['#F7BA2A', '#F7BA2A', '#F7BA2A']" :show-score="true" class="rate"></el-rate>
              </div>
            </div>
            <div v-else-if="item.QuestionsType == 1" class="radio-options-container">
              <el-radio-group v-model="item.QuestionsValue" class="radio-group">
                <el-radio class="radio-option" v-for="(item1, index1) in item.QuestionsOptionsList" :label="item1.Value" :key="index1">{{ item1.Text }}</el-radio>
              </el-radio-group>
            </div>
            <div v-else-if="item.QuestionsType == 2" class="checkbox-options-container">
              <el-checkbox-group v-model="item.QuestionsValueList" class="checkbox-group">
                <el-checkbox class="checkbox-option" v-for="(item1, index1) in item.QuestionsOptionsList" :label="item1.Value" :key="index1">{{ item1.Text }}</el-checkbox>
              </el-checkbox-group>
            </div>
            <div v-else-if="item.QuestionsType == 3">
              <el-input type="textarea" v-model="item.QuestionsValue" placeholder="请描述您对该供应商的真实评价内容..." class="comment-textarea" rows="4"></el-input>
            </div>
            <div v-else-if="item.QuestionsType == 4">
              <div class="upload-area">
                <el-upload
                  action="#"
                  style="width: 50%"
                  class="el_upload"
                  :before-remove="removeConfirm"
                  :on-change="fileChange"
                  :on-exceed="exceedFile"
                  :on-success="handleSuccess"
                  :on-error="handleError"
                  :auto-upload="true"
                  :file-list="item.FileList"
                  :data="{ id: index }"
                  :http-request="uploadFile"
                  :before-upload="handleBeforeUpload"
                  ref="uploader"
                  :on-remove="
                    (file, fileList) => {
                      handleRemove(file, fileList, index)
                    }
                  "
                >
                  <el-button size="mini" type="primary" plain>点击上传</el-button>
                </el-upload>
                <!-- <div class="upload-btn" @click="triggerFileInput">
                  <i class="el-icon-plus"></i>
                  <div class="text">上传图片</div>
                </div>
                <input type="file" ref="fileInput" accept="image/*" @change="onFileChange" style="display: none" />
                <div class="uploaded-image" v-if="uploadedImage">
                  <img :src="uploadedImage" alt="上传的图片" />
                  <div class="delete-btn" @click="deleteImage">×</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 固定提交按钮 (仅在评价页显示) -->
    <div v-if="currentPage === 3" class="submit-btn fixed-bottom">
      <el-button type="primary" size="large" @click="fnSave" class="submit-button" :loading="isSubmitting">{{ isSubmitting ? '提交中...' : '提交评价' }}</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SupplierEvaluation',
  data: function () {
    return {
      code: this.$route.query.code,
      state: this.$route.query.state,
      currentPage: 1,
      evaluationTitle: '',

      uploadedImage: null,
      now: new Date(),
      weekDays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
      serviceSchemeDailyEvaluationTypeList: [],
      evaluationProjectList: [],
      questionnaireList: [],
      selectProject: {},
      isSubmitting: false,
      userName: '',
      jobNo: ''
    }
  },
  computed: {
    currentDate() {
      const year = this.now.getFullYear()
      const month = String(this.now.getMonth() + 1).padStart(2, '0')
      const day = String(this.now.getDate()).padStart(2, '0')
      return `${year}年${month}月${day}日`
    },
    currentWeekDay() {
      return this.weekDays[this.now.getDay()]
    }
  },
  mounted() {
    console.log(this.code)
    console.log(this.state)
    this.Init()
  },
  methods: {
    Init() {
      let config = {
        params: {
          code: this.$route.query.code
        }
      }
      this.getRequest('/SupplierLogin/GetDailyEvaluationProject4Mobile', config).then((res) => {
        if (res.data.errcode == 0) {
          this.serviceSchemeDailyEvaluationTypeList = res.data.serviceSchemeDailyEvaluationTypeList
          this.userName = res.data.userName
          this.jobNo = res.data.jobNo
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    goTo: function (value) {
      this.currentPage = 2
      var selectType = this.serviceSchemeDailyEvaluationTypeList.filter((item) => {
        return item.TypeValue == value
      })[0]
      this.evaluationProjectList = selectType.EvaluationProjectList
      this.evaluationTitle = selectType.TypeName
    },
    goBack: function () {
      if (this.currentPage === 3) {
        this.currentPage = 2
      } else if (this.currentPage === 2) {
        this.currentPage = 1
      }
    },
    goToEvaluation: function (projectId) {
      console.log(this.currentPage)
      this.currentPage = 3
      this.selectProject = this.evaluationProjectList.filter((item) => {
        return item.ProjectId == projectId
      })[0]
      this.questionnaireList = this.selectProject.QuestionnaireList
      this.evaluationTitle = this.selectProject.ProjectAlias
      this.questionnaireList.forEach((item) => {
        item.FileList = []
      })
    },

    uploadFileList(params) {
      const file = params.file
      if (this.questionnaireList[params.data.index].FileList == null) {
        this.questionnaireList[params.data.index].FileList = []
      }
      this.questionnaireList[params.data.index].FileList.push(file)
      console.log(this.questionnaireList[params.data.index].FileList)
    },
    handleDownLoad(file) {
      this.downloadfile('/Common/DownLoadFile?fileId=' + file.fileId)
    },

    formRule() {
      return new Promise((resolve) => {
        this.detailRule()
        resolve(this.rulePass)
      })
    },
    detailRule() {
      this.rulePass = true
      this.questionnaireList.forEach((item) => {
        if (item.QuestionsType != 4 && (item.QuestionsValue == '' || item.QuestionsValue == null) && item.Required && this.rulePass) {
          this.$message.error('请填写第' + item.SerialNum + '题的答案！')
          this.rulePass = false
        }

        if (item.QuestionsType == 4 && (item.FileList == null || item.FileList.length == 0) && item.Required && this.rulePass) {
          this.$message.error('请上传第' + item.SerialNum + '题的附件！')
          this.rulePass = false
        }
      })
    },
    async fnSave(isAudit) {
      this.questionnaireList.forEach((item) => {
        if (item.QuestionsType == 2 || item.QuestionsType == 5) {
          item.QuestionsValue = item.QuestionsValueList.join('#')
        }
      })
      // for (var index = 0; index < this.questionnaireList.length; index++) {
      //   if (this.questionnaireList[index].QuestionsType == 4) {
      //     this.$refs['fileList_' + index][0].submit()
      //   }
      // }
      let isSubmit = await this.formRule()
      if (isSubmit) {
        // this.questionnaireList.forEach((item, index) => {
        //   if (item.QuestionsType == 4) {
        //     console.log(item.FileList)
        //     item.FileList.forEach((item1) => {
        //       form.append('FileList_' + index, item1)
        //     })
        //   }
        // })
        this.selectProject.JobNo = this.jobNo
        this.isSubmitting = true
        this.postRequest('/SupplierLogin/DailyEvaluationProjectSave4Mobile', {
          projectDataJson: JSON.stringify(this.selectProject),
          questionnaireListJson: JSON.stringify(this.questionnaireList)
        }).then((res) => {
          this.isSubmitting = false
          if (res.data.errcode == 0) {
            this.$message({
              type: 'success',
              message: '提交成功!'
            })
            setTimeout(() => {
              this.currentPage = 1
              this.evaluationProjectList = []
              this.questionnaireList = []
              this.selectProject = {}
            }, 1000)
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      }
    },
    uploadFile(params) {
      console.log(params)
      let file = params.file
      var data = new window.FormData()
      let loginToken = ''
      data.append('file', params.file)
      data.append('loginToken', loginToken)
      this.uploadFileRequest('/Common/UploadFile2', data).then((res) => {
        if (res.data.errcode == 0) {
          console.log(res.data)
          let obj = {
            fileId: res.data.FileList[0].id,
            name: res.data.FileList[0].fileName,
            uid: file.uid
          }

          if (this.questionnaireList[params.data.id].FileList.length == 0) {
            var fileList = [obj]
            this.questionnaireList[params.data.id].FileList = fileList
          } else {
            this.questionnaireList[params.data.id].FileList.push(obj)
          }
          params.onSuccess()
        } else {
          this.$message.error(res.data.errmsg)
        }
      })
    },
    exceedFile(files, fileList) {
      this.$message({
        showClose: true,
        message: `最多上传100个文件`,
        type: 'warning'
      })
    },
    // 文件状态改变时的钩子
    fileChange(file, fileList) {},
    // 点击x时执行的钩子函数
    removeConfirm(file, fileList) {
      if (file.status == 'success') {
        return this.$confirm(`确定删除 ${file.name}？`)
      }
    },
    handleRemove(file, fileList, index) {
      console.log(file, fileList, index)
      console.log(this.questionnaireList[index].FileList)
      var list = this.questionnaireList[index].FileList.filter((item1) => {
        return item1.uid == file.uid
      })
      list.forEach((item) => {
        this.postRequest('/Common/DeleteAttachmentByFileId2', {
          fileId: item.fileId
        }).then((res) => {
          if (res.data.errcode == 0) {
            this.questionnaireList[index].FileList = this.questionnaireList[index].FileList.filter((item1) => {
              return item1.uid != file.uid
            })
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
      })
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {},
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.$notify.error({
        title: '上传结果',
        message: `${file.fileName}上传失败:{err}`,
        position: 'bottom-right'
      })
    },
    handleBeforeUpload(file) {}
  }
}
</script>

<style scoped>
/* 使用 vw 单位进行响应式设计 */
.supplier-evaluation {
  width: 100%;
  height: 100vh;
  background-color: #f0f2f5;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  overflow: hidden; /* 防止整体滚动 */
  position: relative; /* 为固定定位提供参照 */
}

/* 固定头部 */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.04vw 4.17vw; /* ~15px 60px on 375px screen */
  background-color: #004a8e;
  color: white;
  height: 10.27vw; /* ~44px */
  box-sizing: border-box;
  z-index: 1000; /* 确保在最顶层 */
}

.header.fixed-top {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}

.header .title {
  font-size: 4vw; /* ~17.3px */
  font-weight: bold;
  flex: 1;
  text-align: center;
  margin-left: -4.17vw; /* 平衡左边按钮的宽度 */
  margin-right: -4.17vw; /* 平衡右边按钮的宽度 */
}

.header .back-btn {
  font-size: 5.56vw; /* ~20px */
  color: white;
  cursor: pointer;
  width: 8.33vw; /* ~30px */
  text-align: left;
}

.header .save-btn {
  font-size: 3.7vw; /* ~13.3px */
  color: #fff;
  cursor: pointer;
  width: 8.33vw; /* ~30px */
  text-align: right;
}

.header .user-icon {
  width: 6.67vw; /* ~24px */
  height: 6.67vw; /* ~24px */
  background-color: rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4.44vw; /* ~16px */
}

/* 页面内容区域 - 可滚动 */
.page-content {
  position: absolute;
  top: 10.27vw; /* 头部高度 */
  left: 0;
  right: 0;
  bottom: 0; /* 如果没有固定底部按钮，则 bottom: 0 */
  overflow-y: auto;
  padding-bottom: 16.67vw; /* 为固定底部按钮预留空间 */
  box-sizing: border-box;
  /* 如果评价页没有固定按钮，需要动态调整此值 */
}

.page-content.no-bottom-btn {
  padding-bottom: 0;
}

/* 页面容器 */
.page-home,
.page-food,
.page-evaluation {
  background-color: white;
  border-radius: 4.44vw; /* ~16px */
  margin: 2.78vw 2.78vw 0; /* ~10px 10px 0 */
  min-height: calc(100vh - 30vw); /* 减去头部高度和 margin */
  box-sizing: border-box;
}

.content {
  padding: 5.56vw; /* ~20px */
}

.date {
  font-size: 3.7vw; /* ~13.3px */
  color: #666;
}

.greeting {
  font-size: 6.11vw; /* ~22px */
  font-weight: bold;
  margin: 2.78vw 0; /* ~10px */
}

.notice {
  font-size: 3.7vw; /* ~13.3px */
  color: #999;
  margin-bottom: 8.33vw; /* ~30px */
}

.icons-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 5.56vw; /* ~20px */
}

.icon-item {
  text-align: center;
  padding: 4.17vw; /* ~15px */
  border-radius: 3.33vw; /* ~12px */
  background-color: #f8f9fa;
  cursor: pointer;
  transition: background-color 0.2s;
  box-sizing: border-box;
}

.icon-item:hover {
  background-color: #edf2f7;
}

.icon-item .icon {
  width: 16.67vw; /* ~60px */
  height: 16.67vw; /* ~60px */
  background-color: #004a8e;
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 6.67vw; /* ~24px */
  margin: 0 auto 2.78vw; /* ~0 auto 10px */
}

.icon-item .label {
  font-size: 3.7vw; /* ~13.3px */
  color: #333;
}

/* 餐饮项目列表 */
.item-list {
  margin-top: 5.56vw; /* ~20px */
}

.item {
  border: 0.28vw solid #e6e6e6; /* ~1px */
  border-radius: 2.78vw; /* ~10px */
  padding: 4.17vw; /* ~15px */
  margin-bottom: 4.17vw; /* ~15px */
  cursor: pointer;
  transition: background-color 0.2s;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

.item:hover {
  background-color: #f5f7fa;
}

.item .item-info {
  flex: 1;
}

.item .name {
  font-size: 4.44vw; /* ~16px */
  font-weight: bold;
  margin-bottom: 1.39vw; /* ~5px */
}

.item .supplier {
  font-size: 3.7vw; /* ~13.3px */
  color: #666;
}

.item .action {
  color: #004a8e;
  font-size: 3.7vw; /* ~13.3px */
  cursor: pointer;
  margin-left: 2.78vw; /* ~10px */
}

/* 评价页面样式 */
.section {
  margin-bottom: 5.56vw; /* ~20px */
  padding: 4.17vw; /* ~15px */
  background-color: #f8f9fa;
  border-radius: 2.22vw; /* ~8px */
  box-sizing: border-box;
}

.section-title {
  font-size: 3.8vw; /* ~16px */
  font-weight: bold;
  margin-bottom: 2.78vw; /* ~10px */
  color: #333;
  position: relative;
  padding-left: 2.78vw; /* ~10px */
  border-left: 0.83vw solid #004a8e; /* ~3px */
}

.rate-item {
  display: flex;
  align-items: center;
  margin-bottom: 2.78vw; /* ~10px */
  font-size: 3.7vw; /* ~13.3px */
}

.rate-item .label {
  flex: 1;
  text-align: left;
}

.rate-item .rate {
  flex: 1;
  margin-left: 2.78vw; /* ~10px */
  text-align: right;
}

/* 优化 el-rate 样式 */
.rate /deep/ .el-rate__item {
  font-size: 5.56vw; /* ~20px */
}
.rate /deep/ .el-rate__text {
  font-size: 3.7vw; /* ~13.3px */
  margin-left: 1.39vw; /* ~5px */
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 2.22vw; /* ~8px */
}

.impression-tag {
  font-size: 3.33vw; /* ~12px */
  height: 6.11vw; /* ~22px */
  padding: 0 2.22vw; /* ~0 8px */
  border-radius: 1.11vw; /* ~4px */
  cursor: pointer;
  user-select: none;
}

.impression-tag /deep/ .el-tag__close {
  font-size: 4.44vw; /* ~16px */
  top: -0.69vw; /* ~-2.5px */
  right: -0.69vw; /* ~-2.5px */
}

.comment-textarea {
  width: 100%;
  border: 0.28vw solid #dcdfe6; /* ~1px */
  border-radius: 1.67vw; /* ~6px */
  font-size: 3.7vw; /* ~13.3px */
  resize: none;
  box-sizing: border-box;
  background-color: white;
}

.upload-area {
  display: flex;
  align-items: center;
  gap: 2.78vw; /* ~10px */
}

.upload-btn {
  width: 22.22vw; /* ~80px */
  height: 22.22vw; /* ~80px */
  border: 0.56vw dashed #ccc; /* ~2px */
  border-radius: 2.22vw; /* ~8px */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: #f5f5f5;
  box-sizing: border-box;
}

.upload-btn i {
  font-size: 6.67vw; /* ~24px */
  color: #999;
}

.upload-btn .text {
  font-size: 3.33vw; /* ~12px */
  color: #666;
  margin-top: 1.39vw; /* ~5px */
}

.uploaded-image {
  position: relative;
  width: 22.22vw; /* ~80px */
  height: 22.22vw; /* ~80px */
  border-radius: 2.22vw; /* ~8px */
  overflow: hidden;
}

.uploaded-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 0;
  right: 0;
  width: 6.67vw; /* ~24px */
  height: 6.67vw; /* ~24px */
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 4.44vw; /* ~16px */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 50%;
  transform: translate(33%, -33%);
}

/* 固定底部提交按钮 */
.submit-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 5.56vw 2.78vw; /* ~20px 10px */
  background-color: #f0f2f5; /* 与背景色一致 */
  z-index: 1000; /* 确保在最顶层 */
  box-sizing: border-box;
}

.submit-btn.fixed-bottom {
  /* 保持 fixed 定位 */
}

.submit-button {
  width: 100%;
  background-color: #004a8e;
  color: white;
  border: none;
  font-size: 4.44vw; /* ~16px */
  padding: 3.33vw 0; /* ~12px 0 */
  border-radius: 2.22vw; /* ~8px */
  height: auto;
  box-sizing: border-box;
}

/* 单选/多选选项样式 - 响应式布局 */
.radio-group,
.checkbox-group {
  margin-top: 2.78vw; /* ~10px */
}

/* 使用 flex 布局进行响应式排列 */
.radio-options-container,
.checkbox-options-container {
  display: flex;
  flex-direction: column; /* 默认垂直排列 */
  gap: 1.39vw; /* ~5px 垂直间距 */
}

.radio-option,
.checkbox-option {
  /* 移除原来的 margin-bottom */
  /* margin-bottom: 1.39vw; */
  display: flex;
  align-items: center; /* 垂直居中 */
  margin-bottom: 2.78vw;
}
.checkbox-option /deep/.el-checkbox__label {
  font-size: 3.7vw;
}
.radio-option /deep/.el-radio__label {
  font-size: 3.7vw;
}
/* 移动端适配 */
@media (max-width: 375px) {
  /* 375px 是基准，无需特殊处理 */
}

@media (max-width: 320px) {
  .header .title {
    font-size: 3.8vw;
  }
  .greeting {
    font-size: 5.56vw;
  }
  .icons-grid {
    gap: 4.8vw;
  }
  .item {
    padding: 3.6vw;
    margin-bottom: 3.6vw;
  }
  .section {
    padding: 3.6vw;
  }
  /* 适配小屏幕的单选/多选 */
  .radio-option /deep/.el-radio__label,
  .checkbox-option /deep/.el-checkbox__label {
    width: 4vw; /* ~14.4px */
    height: 4vw; /* ~14.4px */
  }
  .radio-option .el-radio__label::after,
  .checkbox-option .el-checkbox__label::after {
    width: 2vw; /* ~7.2px */
    height: 2vw; /* ~7.2px */
  }
  .radio-option /deep/.el-radio__label,
  .checkbox-option /deep/.el-checkbox__label {
    font-size: 3.33vw; /* ~12px */
  }
}

@media (min-width: 414px) {
  .header .title {
    font-size: 4.2vw;
  }
  .greeting {
    font-size: 6.67vw;
  }
  .icons-grid {
    gap: 6.11vw;
  }
  .item {
    padding: 4.6vw;
    margin-bottom: 4.6vw;
  }
  .section {
    padding: 4.6vw;
  }
  /* .comment-textarea {
    padding: 3.1vw;
  } */
  /* 适配大屏幕的单选/多选 */
  .radio-option .el-radio__inner,
  .checkbox-option .el-checkbox__inner {
    width: 4.8vw; /* ~19.7px */
    height: 4.8vw; /* ~19.7px */
  }
  .radio-option .el-radio__inner::after,
  .checkbox-option .el-checkbox__inner::after {
    width: 2.4vw; /* ~9.8px */
    height: 2.4vw; /* ~9.8px */
  }
}

/* 在更宽的屏幕上，可以改为水平排列（可选） */
@media (min-width: 576px) {
  .radio-options-container,
  .checkbox-options-container {
    flex-direction: row; /* 水平排列 */
    flex-wrap: wrap; /* 允许换行 */
    gap: 2.78vw; /* ~10px 水平和垂直间距 */
  }
  .radio-option,
  .checkbox-option {
    flex: 0 0 calc(50% - 1.39vw); /* 每行两个，减去一半的 gap */
  }
}

/* Element UI 单选框和复选框大小调整 */
.radio-option .el-radio,
.checkbox-option .el-checkbox {
  font-size: 3.7vw; /* ~13.3px */
  width: 100%; /* 确保选项占满容器 */
}

.radio-option .el-radio__inner,
.checkbox-option .el-checkbox__inner {
  width: 4.44vw; /* ~16px */
  height: 4.44vw; /* ~16px */
}

.radio-option .el-radio__inner::after,
.checkbox-option .el-checkbox__inner::after {
  width: 2.22vw; /* ~8px */
  height: 2.22vw; /* ~8px */
  transform: scale(0.7) translate(-50%, -50%);
}

.radio-option /deep/.el-radio__label,
.checkbox-option /deep/.el-checkbox__label {
  font-size: 3.7vw; /* ~13.3px */
  word-break: break-word; /* 防止长单词或URL撑破容器 */
  padding-left: 1.39vw; /* ~5px 与选项框间距 */
}
</style>